import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { api } from "../axios/api";
import { notify } from "../utils/toastAlert";

const SqlImportButton = ({ endpoint, label = "Importar SQL", disabled = false, onImported, headers = {} }) => {
  const fileInputRef = useRef(null);
  const [importing, setImporting] = useState(false);

  const summarize = (data) => {
    if (!data) return "Importacao concluida.";

    if (data.users || data.series || data.clientes || data.produtos || data.documentos) {
      return ["users", "series", "clientes", "produtos", "documentos"]
        .filter((key) => data[key])
        .map((key) => `${key}: ${data[key].created || 0} criados, ${data[key].updated || 0} actualizados`)
        .join(" | ");
    }

    const created = data.created || 0;
    const updated = data.updated || 0;
    const skipped = data.skipped || 0;
    const items = data.itemsCreated ? `, ${data.itemsCreated} itens` : "";
    return `${created} criados, ${updated} actualizados, ${skipped} ignorados${items}.`;
  };

  const handleImport = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;

    if (!file.name.toLowerCase().endsWith(".sql")) {
      await notify("Selecione um ficheiro .sql.", "warning");
      return;
    }

    try {
      setImporting(true);
      const formData = new FormData();
      formData.append("file", file);
      const response = await api.post(endpoint, formData, {
        headers: { "Content-Type": "multipart/form-data", ...headers },
      });
      await notify(summarize(response.data?.data), "success");
      await onImported?.();
    } catch (err) {
      await notify(err.response?.data?.error || err.message || "Nao foi possivel importar o ficheiro.", "error");
    } finally {
      setImporting(false);
    }
  };

  return (
    <>
      <input ref={fileInputRef} type="file" accept=".sql" className="d-none" onChange={handleImport} />
      <button
        className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1"
        type="button"
        onClick={() => fileInputRef.current?.click()}
        disabled={disabled || importing}
      >
        <Upload size={16} />
        {importing ? "A importar..." : label}
      </button>
    </>
  );
};

export default SqlImportButton;
